import { Card, CardHeader, PageHeader } from '@biovet/ui';
import { REPORT_GROUPS } from '../lib/design-data.js';

export function ReportsScreen({ onOpen }: { onOpen: (item: string) => void }) {
  return (
    <>
      <PageHeader
        breadcrumb="Reports / Library"
        title="Report library"
        description="Every report you can open, print or export, in one place."
      />

      <div className="grid gap-3.5 md:grid-cols-2 xl:grid-cols-3">
        {REPORT_GROUPS.map((group) => (
          <Card key={group.title} flush>
            <CardHeader
              title={group.title}
              actions={
                <span className="bb-num text-[11px] text-[var(--ink-3)]">{group.items.length}</span>
              }
            />
            <div className="flex flex-col p-1.5">
              {group.items.map((item) => {
                const target = BUILT[item];
                return (
                  <button
                    key={item}
                    type="button"
                    onClick={target ? () => onOpen(target) : undefined}
                    disabled={!target}
                    className={
                      target
                        ? 'flex w-full cursor-pointer items-center gap-2.5 rounded-[var(--radius-sm)] border-0 bg-transparent px-2.5 py-1.5 text-left text-[12.5px] text-[var(--ink-2)] hover:bg-[var(--surface-2)] hover:text-[var(--accent)]'
                        : 'flex w-full items-center gap-2.5 rounded-[var(--radius-sm)] border-0 bg-transparent px-2.5 py-1.5 text-left text-[12.5px] text-[var(--ink-3)]'
                    }
                  >
                    <span
                      aria-hidden="true"
                      className="size-1 shrink-0 rounded-full bg-current opacity-45"
                    />
                    <span>{item}</span>
                  </button>
                );
              })}
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}

const BUILT: Record<string, string> = {
  'General Ledger': 'gl',
  'Trial Balance': 'tb',
  'Profit & Loss': 'pl',
  'Balance Sheet': 'bs',
  'AR Ageing': 'rpt-ageing',
  'AP Ageing': 'payables',
  'Sales by Zone': 'rpt-saleszone',
  'Sales by Salesperson': 'rpt-saleszone',
  'Gross Margin Analysis': 'rpt-margin',
  'Audit Trail Report': 'rpt-audit',
  'Stock Ledger': 'stock-ledger',
  'Stock Summary (warehouse-wise)': 'stock',
  'Batch & Expiry': 'batch',
  'Purchase Register': 'purchase',
  'Purchase Return Register': 'preturn',
  'Sale Return Register': 'sreturn',
  'Import Costing Sheet': 'costing',
  'Deal Register': 'deal-register',
  'Pending Settlement': 'settlement',
  'Import Deal Tracker': 'tracker',
  'Tally Variance': 'count',
};
